import { useMutation } from "@tanstack/react-query";
import { Link, useSearch } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { ContentHeader } from "@cx/ui";
import { errorMessage } from "../../errors";
import { useSession } from "../../session";

/**
 * "Tela de autorização" do Melhor Envio de testes (T3.4, só fora de produção): autorizar devolve a query que o
 * Melhor Envio mandaria ao redirect e segue para o mesmo retorno da conta real.
 */
export function MelhorEnvioSandboxConsentPage(): ReactElement {
  const { api } = useSession();
  const { state } = useSearch({ from: "/integracoes/logistica/melhor-envio/sandbox" });
  const authorize = useMutation({
    mutationFn: () =>
      api<{ query: string }>("/logistics/integrations/melhorenvio/sandbox/authorize", {
        method: "POST",
        body: JSON.stringify({ state }),
      }),
    onSuccess: (r) => window.location.replace(`/integracoes/logistica/melhor-envio/retorno?${r.query}`),
  });
  return (
    <>
      <ContentHeader
        title="Melhor Envio de testes"
        breadcrumb={["Preferências", "Integrações", "Logística", "Melhor Envio"]}
      />
      <div className="box card p-3" style={{ maxWidth: 560 }}>
        <p>
          O <strong>CX ERP</strong> quer acessar sua conta de testes: cotar fretes, comprar e imprimir
          etiquetas e rastrear envios. Nenhuma conta real do Melhor Envio é usada.
        </p>
        {authorize.isError && <div className="alert alert-danger py-2">{errorMessage(authorize.error)}</div>}
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary"
            disabled={!state || authorize.isPending}
            onClick={() => authorize.mutate()}
          >
            Autorizar
          </button>
          <a
            className="btn btn-outline-secondary"
            href="/integracoes/logistica/melhor-envio/retorno?error=access_denied"
          >
            Recusar
          </a>
        </div>
        <p className="small text-muted mt-3 mb-0">
          <Link to="/preferencias/integracoes/logistica">Voltar para a logística</Link>
        </p>
      </div>
    </>
  );
}
